module.exports = __webpack_public_path__ + "media/images/ok-icon-small-1b569e0480549de0dc0ed0c70a01f063.png";